import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import styles from "../../../SticksForm.module.scss";
export const QuantityGroupTitle = ({ step }) => {
    const { __ } = useTranslations();
    return (_jsxs(_Fragment, { children: [_jsx("strong", { className: styles.stepCountLabel, children: __(`sticksForm.step.order_text.${step}`) }), " ", __("sticksForm.step.quantity_selection.title")] }));
};
//# sourceMappingURL=QuantityGroupTitle.js.map